{
  class ProductIndexItem extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (window.matchMedia("(hover: hover)").matches) {
        this.template = this.querySelector("template");
        if (this.template) {
          this.addEventListener(
            "mouseenter",
            (event) => {
              this.renderTemplate();
            },
            false
          );
        }
      }
      this.quickViewButton = this.querySelector(".quick-view-button-wrapper");
      this.quickViewButton.addEventListener(
        "click",
        (event) => {
          if (window.vsp && vsp.quickView) {
            event.preventDefault();
            const productUrl = this.quickViewButton.getAttribute("href");
            vsp.quickView.updateAndShow(productUrl);
          }
        },
        false
      );
    }
    disconnectedCallback() {
    }
    renderTemplate() {
      var documentFragment = this.template.content;
      var templateClone = documentFragment.cloneNode(true);
      this.template.after(templateClone);
    }
  }
  if (!customElements.get("product-index-item")) {
    customElements.define("product-index-item", ProductIndexItem);
  }
  class ProductIndexItemSlideshow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        this.setupSlideshow();
      });
    }
    disconnectedCallback() {
    }
    setupSlideshow() {
      new Swiper(this, {
        // configure Swiper to use modules
        // modules: [Navigation, Pagination],
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    }
  }
  if (!customElements.get("product-index-item-slideshow")) {
    customElements.define("product-index-item-slideshow", ProductIndexItemSlideshow);
  }
}
